import {GALinkStatus} from '../../util/uiconstants';

const normalizeItem = ({id: value, name: label, snapshotId}) => ({value, label, snapshotId});

export default (teams) => {
	const normalized = teams
		.filter(
			({linkStatusId}) =>
				linkStatusId !== GALinkStatus.NoPointOfContact &&
				linkStatusId !== GALinkStatus.InvalidPointOfContact &&
				linkStatusId !== GALinkStatus.ComponentReferenceOnly
		)
		.sort((a, b) => a.name.localeCompare(b.name))
		.map(normalizeItem);

	return normalized;
};
